import React from "react";
import styled from "styled-components";
import { ModalSubmit, Spinner } from "components/common";
import { Button } from "components/bootstrap";
const SubmitTextRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacings.xs};
`;
const EventDefinitionFormControls = ({
  action,
  activeStepIndex,
  onCancel,
  onOpenNextPage,
  onOpenPrevPage,
  onSubmit,
  steps,
  isSubmitting = false,
  disabledSubmit = false
}) => {
  const isEditing = action === "edit";
  const submitText = isSubmitting ? isEditing ? "Updating..." : "Creating..." : isEditing ? "Update Event Definition" : "Create Event Definition";
  if (activeStepIndex === steps.length - 1) {
    return /* @__PURE__ */ React.createElement(
      ModalSubmit,
      {
        onCancel,
        onSubmit,
        disabledSubmit: disabledSubmit || isSubmitting,
        submitButtonText: /* @__PURE__ */ React.createElement(SubmitTextRow, null, isSubmitting && /* @__PURE__ */ React.createElement(Spinner, { text: "" }), submitText)
      }
    );
  }
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Button, { bsStyle: "info", onClick: onOpenPrevPage, disabled: activeStepIndex === 0 }, "Previous"), /* @__PURE__ */ React.createElement("div", { className: "pull-right" }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "info", onClick: onOpenNextPage }, "Next")));
};
export default EventDefinitionFormControls;
